module.exports = __webpack_public_path__ + "img/philips.5ab07c91.svg";